import * as yup from 'yup';
import { EMAIL_REGEX, NAME_REGEX, USER_ROLE_REGEX, USER_ROLE_WITH_RUNNER_REGEX, } from '../../constants/regex';
import { EMAIL_INVALID_BULK_ADD, EMAIL_REQUIRED_BULK_ADD, FIRST_NAME_REQUIRED_BULK_ADD, FIRST_NAME_TOO_LONG, INVALID_FIELD_BULK_ADD, LAST_NAME_REQUIRED_BULK_ADD, LAST_NAME_TOO_LONG, ROLE_REQUIRED_BULK_ADD, } from '../../constants/field-error-messages';
export var getUserSchema = function (isPartOfRunnerAllowance) {
    return yup.object().shape({
        firstName: yup
            .string()
            .nullable()
            .required(FIRST_NAME_REQUIRED_BULK_ADD.message)
            .trim()
            .max(40, FIRST_NAME_TOO_LONG.message)
            .matches(NAME_REGEX, INVALID_FIELD_BULK_ADD.message),
        lastName: yup
            .string()
            .nullable()
            .required(LAST_NAME_REQUIRED_BULK_ADD.message)
            .trim()
            .max(60, LAST_NAME_TOO_LONG.message)
            .matches(NAME_REGEX, INVALID_FIELD_BULK_ADD.message),
        email: yup
            .string()
            .nullable()
            .required(EMAIL_REQUIRED_BULK_ADD.message)
            .matches(EMAIL_REGEX, EMAIL_INVALID_BULK_ADD.message),
        role: yup
            .string()
            .nullable()
            .required(ROLE_REQUIRED_BULK_ADD.message)
            .matches(isPartOfRunnerAllowance ? USER_ROLE_WITH_RUNNER_REGEX : USER_ROLE_REGEX, ROLE_REQUIRED_BULK_ADD.message),
    });
};
export var validationSchema = yup.object().shape({
    isPartOfRunnerAllowance: yup.boolean(),
    users: yup.array().when('isPartOfRunnerAllowance', {
        is: true,
        then: function (schema) { return schema.of(getUserSchema(true)); },
        otherwise: function (schema) { return schema.of(getUserSchema(false)); },
    }),
});
